import { Grid } from '@mui/material';
import Typography from '@mui/material/Typography';

interface ClaimTowingRepairDataModel {
  serviceRequestData?: any;
}
export default function ClaimDetailRepair(props?: ClaimTowingRepairDataModel) {
  return (
    <Grid container sx={{ py: '1rem' }}>
      {props?.serviceRequestData && props?.serviceRequestData.length > 0 && (
        <Grid container>
          <Grid item xs={4}>
            <Typography variant="body1" sx={{ m: '1rem' }}>
              <b>Repair Shop</b>
            </Typography>
          </Grid>

          <Grid item xs={8}>
            <Typography variant="body1" sx={{ mr: '2rem', textAlign: 'left' }}>
              {props.serviceRequestData[0].providerName}
            </Typography>
            <Typography variant="body1" sx={{ mr: '2rem', textAlign: 'left' }}>
              {props.serviceRequestData[0].providerAddress}
            </Typography>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}
